import { ChangeDetectorRef, Component, OnInit, Renderer2 } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { Subject } from 'rxjs';
import { CommonService } from './modules/common/service/common/common.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    topbarTheme = 'dim';
    menuTheme = 'dim';
    layoutMode = 'light';
    menuMode = 'horizontal';
    isRTL = false;
    inputStyle = 'outlined';
    ripple: boolean;
    private unsubscribe = new Subject<void>();
    isAuthenticated: boolean = false;
    activeUser: string | undefined = "unknown user";
    constructor(public renderer: Renderer2, public loaderService: CommonService, private primengConfig: PrimeNGConfig) { }

    ngOnInit() {
        this.primengConfig.ripple = true;
        this.renderer.setStyle(document.body, 'font-family', 'Montserrat');
    }
    get loaderEnabled() {
        return this.loaderService.loaderEnabled;
    }
    ngOnDestroy() {
        this.unsubscribe.next(undefined);
        this.unsubscribe.complete();
    }
}
